import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { ReactComponent as CheerzLiveIcon } from "@Icons/cheerz-live.svg";
import { ReactComponent as GiftIcon } from "@Icons/gift.svg";
import { ReactComponent as HandHeartIcon } from "@Icons/hand-heart.svg";
import { Category } from "@Types/header";
import { cheerzLiveLink, engagementsLinks, giftLink } from "@Utils/links";
import HeaderMobileCategoryItem from "./HeaderMobileCategoryItem";
import "./style.scss";

interface Props {
  categories: Category[];
  featuredCategories?: Category[];
}

const HeaderMobileCategories: FunctionComponent<Props> = ({ categories, featuredCategories }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const engagementsLinkWithLocale = engagementsLinks[intl.locale];

  return (
    <div className="HeaderMobileCategories">
      {featuredCategories &&
        featuredCategories.map((category: Category) => {
          return <HeaderMobileCategoryItem key={category.tag} category={category} />;
        })}
      {categories.map((category: Category) => {
        return <HeaderMobileCategoryItem key={category.tag} category={category} />;
      })}
      <div className="HeaderMobileCategories-links">
        <a href={`/${localeSlug}${giftLink}`} className="HeaderMobileCategories-link">
          <GiftIcon />
          <div className="HeaderMobileCategories-label">
            {intl.formatMessage({ id: "cheerz_Header_giftIdeas" })}
          </div>
        </a>
        {localeSlug === "fr" && (
          <a href={`/${localeSlug}${cheerzLiveLink}`} className="HeaderMobileCategories-link">
            <CheerzLiveIcon />
            <div className="HeaderMobileCategories-label">
              {intl.formatMessage({ id: "cheerz_Header_photobooth" })}
            </div>
          </a>
        )}
        {engagementsLinkWithLocale && (
          <a href={engagementsLinkWithLocale} className="HeaderMobileCategories-link">
            <HandHeartIcon />
            <div className="HeaderMobileCategories-label">
              {intl.formatMessage({ id: "cheerz_Header_engagements" })}
            </div>
          </a>
        )}
      </div>
    </div>
  );
};

export default HeaderMobileCategories;
